// extracted by mini-css-extract-plugin
module.exports = {"modal":"_2KGdR_WznzUyIg-kcNCJlN"};